// extracted by mini-css-extract-plugin
module.exports = {"UnTouch":"UnTouchLayer_UnTouch__1Xwr2","Touch":"UnTouchLayer_Touch__lQ5zy"};